import React from 'react';

import { NavLink } from 'react-router-dom';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
 
const Radio = () => {
    return (
        <div className="radio">
            <div>
                <div className="bio-nav menu">
                    <NavLink to="/doublage">
                        <h1>Doublage</h1>
                    </NavLink>
                </div>
                <div className="bio-nav menu bis">
                    <NavLink to="/radio">
                        <h1>Radio</h1>
                    </NavLink>
                </div>
                <div className="bio-nav menu">
                    <NavLink to="/musique">
                        <h1>Musique</h1>
                    </NavLink>  
                </div>
                <div className="border"></div>
            </div>
            <div className="intro">
                Je suis, depuis plusieurs mois, chroniqueur pour la radio <span><a rel="noopener noreferrer" href="http://www.enjyradio.fr/" target="_blank">EnjyRadio.fr</a></span>. C'est une web radio généraliste jeune et dynamique qui diffuse depuis le 21 Janvier 2017. EnjyRadio propose des émissions de type Talk, libre-antenne et évidemment des émissions musicales.
            </div>
            <div className="extract">
                <img src={require('../img/profil-radio.png')} alt={""} />
                <AudioPlayer
                    src={require("../song/Radio/Yannick - ZFE 55 - 1ère.mp3")}
                />
            </div>
            <div className="extract">
                <img src={require('../img/profil-radio.png')} alt={""} />
                <AudioPlayer
                    src={require("../song/Radio/Yannick - ZFE 56 - 2ème.mp3")}
                    onPlay={e => console.log("onPlay")}
                />
            </div>
            <div className="extract">
                <img src={require('../img/profil-radio.png')} alt={""} />
                <AudioPlayer
                    src={require("../song/Radio/Yannick - ZFE 57 - 3ème.mp3")}
                />
            </div>
            <div className="extract">
                <img src={require('../img/profil-radio.png')} alt={""} />
                <AudioPlayer
                    src={require("../song/Radio/Yannick - ZFE 61 - 5ème.mp3")}
                    onPlay={e => console.log("onPlay")}
                />
            </div>
        </div>
    );
}
 
export default Radio;